<script setup>
import { storeToRefs } from 'pinia'
import { usePortalsStore } from '@/stores/portals'
import CustomTabs from '@/components/CustomTabs.vue'
import CustomTab from '@/components/CustomTab.vue'
import ExchangesForm from '@/components/settings/ExchangesForm.vue'
import ReturnsForm from '@/components/settings/ReturnsForm.vue'
import AccountInfoForm from "@/components/settings/AccountInfoForm.vue"
import ShippingForm from '@/components/settings/ShippingForm.vue'

const { selectedPortal } = storeToRefs(usePortalsStore())
</script>

<template>
  <CustomTabs>
    <CustomTab
      title="Account Info"
      :draft="selectedPortal.fields.settings.accountInfo.hasChanges"
      :error="selectedPortal.fields.settings.accountInfo.hasErrors"
    >
      <AccountInfoForm/>
    </CustomTab>
    <CustomTab
      title="Returns"
      :draft="selectedPortal.fields.settings.returns.hasChanges"
      :error="selectedPortal.fields.settings.returns.hasErrors"
    >
      <ReturnsForm/>
    </CustomTab>
    <CustomTab
      title="Repurchases"
      :draft="selectedPortal.fields.settings.repurchases.hasChanges"
      :error="selectedPortal.fields.settings.repurchases.hasErrors"
    >
      <ExchangesForm />
    </CustomTab>
    <CustomTab
      title="Shipping"
      :draft="selectedPortal.fields.settings.shipping.hasChanges"
      :error="selectedPortal.fields.settings.shipping.hasErrors"
    >
      <ShippingForm />
    </CustomTab>
  </CustomTabs>
</template>
